export const pricingChangesFilterState = () => ({
  startDate: null,
  endDate: null,
});
